import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { msg } from 'gt-react';
import { z } from 'zod';
import { MAX_LABELING_TABLES } from 'src/components/schema-definitions/labeling/labelingSession';
import { Route as authenticatedRoute } from '../../../../route';

const labelingSearchSchema = z.object({
  schemaIds: z.array(z.uuid()).max(MAX_LABELING_TABLES).optional(),
  /** Skip table selection and open the review straight away. */
  start: z.boolean().optional(),
  /** Where the back link returns to. */
  from: z.enum(['data-sources']).optional(),
});

export const Route = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/settings/organization/schema-definitions/labeling',
  component: lazyRouteComponent(
    () => import('./SchemaLabelingPage'),
    'SchemaLabelingPage',
  ),
  validateSearch: labelingSearchSchema,
  loader: () => ({
    crumb: msg('Label SQL tables', { context: 'schema labeling breadcrumb' }),
  }),
});
